'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var ReactDOM = _interopDefault(require('react-dom'));
var styles$j = require('./styles-4395bd12.js');
var backButton = require('./back-button-b7859379.js');
var closeButton = require('./close-button-1f237b1c.js');

var ModalWrapper = function (_a) {
    var visible = _a.visible, content = _a.content, onClose = _a.onClose, exitOnBackgroundClick = _a.exitOnBackgroundClick, backgroundColor = _a.backgroundColor, withExitButton = _a.withExitButton, onPressBack = _a.onPressBack, withBackButton = _a.withBackButton, backButtonVariant = _a.backButtonVariant, backButtonText = _a.backButtonText, className = _a.className, closeButtonText = _a.closeButtonText, headerElement = _a.headerElement;
    React.useEffect(function () {
        document.body.style.overflow = visible ? 'hidden' : 'initial';
        return function () {
            document.body.style.overflow = 'initial';
        };
    }, [visible]);
    var _b = tslib_es6.__read(React.useState(false), 2), isVisible = _b[0], setIsVisible = _b[1];
    var toggle = React.useCallback(function () {
        setIsVisible(!isVisible);
    }, [isVisible]);
    var handleExitOnBackGroundClick = React.useCallback(function () {
        var _a;
        if (exitOnBackgroundClick) {
            return (_a = onClose === null || onClose === void 0 ? void 0 : onClose()) !== null && _a !== void 0 ? _a : toggle();
        }
        return null;
    }, [exitOnBackgroundClick, onClose, toggle]);
    var modal = (React__default.createElement("div", { className: className },
        React__default.createElement(styles$j.Background, { onClick: handleExitOnBackGroundClick, "data-testid": "modal-background", className: "modal-background" }),
        React__default.createElement(styles$j.Container, { backgroundColor: backgroundColor, "data-testid": "modal-wrapper", className: "modal-wrapper" },
            withBackButton
                && (React__default.createElement(backButton.BackButton, { onPressBack: onPressBack, toggle: toggle, backButtonVariant: backButtonVariant, backButtonText: backButtonText })),
            withExitButton && React__default.createElement(closeButton.CloseButton, { onClose: onClose, toggle: toggle, closeButtonText: closeButtonText }),
            headerElement && (React__default.createElement(styles$j.HeaderElement, { className: "header-element", "data-testid": "header-element" }, headerElement)),
            React__default.createElement(styles$j.Content, { className: "modal-wrapper-content" }, content))));
    return visible ? ReactDOM.createPortal(modal, document.body) : null;
};

exports.ModalWrapper = ModalWrapper;
